import {EFieldType, IMetaActionInfo, ITableEntityMeta} from 'entities/metadata';

interface IPickDataFromQueryByAdditionalFieldsArgs {
    additionalInfoKeys: IMetaActionInfo['additionalInfoKeys'];
    getQueryParam: (name: string) => string | null;
}

export const pickDataFromQueryByAdditionalFields = ({
    additionalInfoKeys,
    getQueryParam,
}: IPickDataFromQueryByAdditionalFieldsArgs): Record<string, string> => {
    const valuesFromQuery: Record<string, any> = {};

    if (getQueryParam) {
        additionalInfoKeys
            ?.filter((key: string) => getQueryParam(key) != null)
            ?.forEach((key: string) => {
                valuesFromQuery[key] = getQueryParam(key);
            });
    }

    return valuesFromQuery;
};

interface IShouldPickDataFromQueryByAdditionalInfoKeysArgs {
    filterMeta: ITableEntityMeta;
}

export const shouldPickDataFromQueryByAdditionalInfoKeys = (
    {filterMeta}: IShouldPickDataFromQueryByAdditionalInfoKeysArgs,
) => filterMeta?.fields?.some(f => f?.type === EFieldType.QUERY_PARAMS_BOUND_SELECT);
